"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _TabNavigation = _interopRequireDefault(require("../navigations/TabNavigation"));
var _TabContent = _interopRequireDefault(require("../layout-wrappers/TabContent"));
function TabbedContent(_ref) {
  let {
    tabs = [],
    navRightSideContent
  } = _ref;
  const [currentTab, setCurrentTab] = (0, _react.useState)(tabs[0]);
  const onTabChanged = tab => setCurrentTab(tab);
  return /*#__PURE__*/_react.default.createElement("tabbed-content", null, /*#__PURE__*/_react.default.createElement(_TabNavigation.default, {
    tabs: tabs,
    onTabChanged: onTabChanged
  }, navRightSideContent && navRightSideContent), /*#__PURE__*/_react.default.createElement(_TabContent.default, {
    content: currentTab.content,
    classname: currentTab.classname ? currentTab.classname : null
  }));
}
var _default = exports.default = TabbedContent;